import type { UiLinkComponent } from '@portals-platform/ui';
import { Link } from '@tanstack/react-router';

/**
 * The single place this app-core binds `packages/ui`'s router-agnostic
 * `UiLinkComponent` contract to a concrete router. Swapping routers in the
 * future means updating this file (and `router.tsx`) only.
 */
export const AppLink: UiLinkComponent = ({ href, className, children }) => (
  <Link to={href} className={className}>
    {children}
  </Link>
);
